const toPositiveInt = (value, fallback = 1) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const toFiniteNumber = (value, fallback = 0) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

export const isLockedModelForCheckoutRefresh = (model, order = null) => {
    if (order?.lock_order_prices === true) {
        return true;
    }

    return model?.admin_edited === true || model?.price_locked === true;
};

export const buildCheckoutModelRefreshPayload = (models = [], order = null, resolveSettingsId) => {
    if (!Array.isArray(models) || typeof resolveSettingsId !== "function") {
        return [];
    }

    return models
        .filter((model) => !isLockedModelForCheckoutRefresh(model, order))
        .map((model) => {
            const settingsId = model?.pivot?.materials_in_applications ?? resolveSettingsId(model);
            const amount = toPositiveInt(model?.amount ?? model?.pivot?.amount, 1);

            if (!model?.id || !settingsId) {
                return null;
            }

            return {
                id: model.id,
                settings: settingsId,
                amount,
            };
        })
        .filter(Boolean);
};

export const applyCheckoutModelRefresh = (models = [], refreshedRows = [], order = null) => {
    if (!Array.isArray(models)) {
        return [];
    }

    const refreshedByModelId = Array.isArray(refreshedRows)
        ? refreshedRows.reduce((acc, row) => {
              if (row?.model_id) {
                  acc[row.model_id] = row;
              }

              return acc;
          }, {})
        : {};

    return models.map((model) => {
        if (isLockedModelForCheckoutRefresh(model, order)) {
            return model;
        }

        const refreshed = refreshedByModelId[model.id];
        const hasNumericPrice = refreshed && Number.isFinite(Number.parseFloat(refreshed.unit_price));
        if (!hasNumericPrice) {
            return model;
        }

        const unitPrice = toFiniteNumber(refreshed.unit_price);
        const discountMultiplier = toFiniteNumber(refreshed.discount_multiplier, 1);
        const amount = toPositiveInt(model?.pivot?.amount ?? model?.amount, 1);

        const nextModel = {
            ...model,
            price: unitPrice,
            discount_multiplier: discountMultiplier,
        };

        if (model?.pivot) {
            const pivot = {
                ...model.pivot,
                price: unitPrice,
            };

            if (discountMultiplier !== 1) {
                pivot.discount_price = Number.parseFloat((unitPrice * amount * discountMultiplier).toFixed(2));
            } else {
                pivot.discount_price = null;
            }

            nextModel.pivot = pivot;
        }

        return nextModel;
    });
};
